/**
 * Shared display formatting per the Canopy design standards.
 *
 *   - datetime.md: 24-hour clock, `MMM D, YYYY, HH:mm`
 *   - content-style.md: empty values render as an en dash, never blank
 */

/** The standard empty-value marker. */
export const EM_DASH = '–';

/** 24-hour date-time per standards/datetime.md (MMM D, YYYY, HH:mm). */
export function fmtDateTime(iso: string | null | undefined): string {
  if (!iso) return EM_DASH;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return EM_DASH;
  return d.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}

/**
 * A data date as the API returns it ('YYYY-MM-DD' or 'YYYY-MM-DD HH:MM:SS',
 * UTC) per standards/datetime.md: `MMM D, YYYY`, plus `, HH:mm` when it
 * carries a time. Shown in UTC: it is a day in the data, and converting
 * it to the viewer's zone could move it to the day before.
 */
export function fmtDataDate(value: string | null | undefined): string {
  if (!value) return EM_DASH;
  const m = /^(\d{4}-\d{2}-\d{2})(?:[ T](\d{2}:\d{2})(?::\d{2})?)?/u.exec(value);
  if (!m) return EM_DASH;
  const d = new Date(`${m[1]}T${m[2] ?? '00:00'}:00Z`);
  if (Number.isNaN(d.getTime())) return EM_DASH;
  return d.toLocaleString('en-US', {
    timeZone: 'UTC',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    ...(m[2] ? { hour: '2-digit', minute: '2-digit', hour12: false } : {}),
  });
}
